import { createRoot } from 'react-dom/client'
import CompactShopTheLook from './components/CompactShopTheLook'

declare global {
  interface Window {
    routes: {
      rootUrlWithoutSlash: string
      domain: string
    }
  }
}

/* The block is output in both the desktop and the mobile PDP column, so mount every instance. */
const mountAll = (scope: ParentNode = document) => {
  scope.querySelectorAll<HTMLElement>('[data-compact-shop-the-look]').forEach((mount) => {
    if (mount.dataset.mounted === 'true') return

    mount.dataset.mounted = 'true'
    createRoot(mount).render(<CompactShopTheLook mount={mount} />)
  })
}

mountAll()

/* Re-mount when the merchant edits the section in the theme editor. */
document.addEventListener('shopify:section:load', (event: any) => {
  mountAll(event.target || document)
})
